// registries/index.js

import { landingRegistry } from "./landingRegistry";
import { authenticationRegistry } from "./authenticationRegistry";
import { appRegistry } from "./appRegistry";

export const appRegistries = {
  landing: landingRegistry,
  authentication: authenticationRegistry,
  app: appRegistry,
};
